import PropTypes from "prop-types";
import React, { createContext, useContext, useEffect, useMemo, useReducer } from "react";
// routes
import { usePathname } from "src/routes/hook";
// hooks
import usePrevious from "src/hooks/use-previous";

// ----------------------------------------------------------------------

const NavigationContext = createContext();

const initialState = {
    prevPath: null,
    currentPath: null
};

const reducer = (state, action) => {
    if (action.type === "UPDATE") {
        return {
            prevPath: action.payload?.prevPath ?? "",
            currentPath: action.payload?.currentPath ?? ""
        };
    }

    return state;
};

export const NavigationProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const pathname = usePathname();

    const prevPath = usePrevious(pathname);

    const contextValue = useMemo(() => ( { ...state } ), [state]);

    // ----------------------------------

    useEffect(() => {
        dispatch({
            type: "UPDATE",
            payload: {
                prevPath,
                currentPath: pathname
            }
        });
    }, [pathname]);

    return (
        <NavigationContext.Provider value={contextValue}>
            {children}
        </NavigationContext.Provider>
    );
};

NavigationProvider.propTypes = {
    children: PropTypes.node
};

export const useNavigation = () => useContext(NavigationContext);
